import { render, staticRenderFns } from "./GDialogContainer.vue?vue&type=template&id=566d2e94&"
import script from "./GDialogContainer.vue?vue&type=script&lang=js&"
export * from "./GDialogContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports